import { useEffect, useState } from 'react';
import styled from 'styled-components';
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import background1 from '../../src/assets/images/landing/background1.jpg';
import client from '../utils/contentfulClient';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { renderOptions } from '../utils/contentfulClient';
import Spinner from '../components/Spinner';

const About = styled.div`
    background: url(${background1}) no-repeat center center/cover;
    position: relative;
    min-height: 100vh;

    * {
        box-sizing: border-box;
        color: white;
        font-family: 'Montserrat', sans-serif;
    }
`;

const Overlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(84, 147, 183, 0.4);
`;

const AboutWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5rem 0;
    position: relative;
    min-height: 100vh;

    @media (min-width: 768px) {
        padding: 5rem 3rem;
    }
`;

const GradientWrapper = styled.div`
    background: radial-gradient(
        circle at left center,
        #508db0 35%,
        #508db0 35%,
        #101f3f 65%
    );
    width: 88%;
    margin: 50px auto;
    display: flex;
    flex-wrap: wrap;
    padding: 2rem 2rem 5rem 2rem;
`;

const Title = styled.h1`
    font-size: 2.8rem;
`;

const LoadingWrapper = styled.div`
    width: 100%;
`

const AboutPage = () => {
    const [content, setContent] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        client
            .getEntries({ content_type: 'landingPage' })
            .then((response) => {
                if (response.items.length > 0) {
                    setContent(response.items[0].fields);
                }
                setLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching content: ', error);
                setLoading(false);
            });
    }, []);

    return (
        <About>
            <Overlay />
            <AboutWrapper>
                <NavBar />
                    { loading ? (
                        <LoadingWrapper>
                            <Spinner />
                        </LoadingWrapper>
                    ) : (
                        <GradientWrapper>
                            <Title>{content.aboutTitle}</Title>
                            {documentToReactComponents(content.aboutDescription, renderOptions)}
                        </GradientWrapper>
                    )}
            </AboutWrapper>
            <Footer />
        </About>
    );
};

export default AboutPage;
